/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { POPUP_SETTINGS_RTL as o, POPUP_SETTINGS as d } from "../consts.mjs";
import { isIdZeroLevel as i } from "./itemsIdsUtils.mjs";
function l(r, n, t) {
  const e = w(r, n, t);
  return t ? e === "downward" ? o.downward : o.leftward : e === "downward" ? d.downward : d.rightward;
}
function w(r, n, t) {
  return i(r) ? n ? t ? "leftward" : "rightward" : "downward" : t ? "leftward" : "rightward";
}
function f(r) {
  return r ? "rtl" : "ltr";
}
function P(r, n) {
  return `${r}_${n}`;
}
export {
  f as convertBoolDirectionToString,
  w as getChildrenPosition,
  P as getDOMElementId,
  l as getPopupSettings
};
